export const fmtMoney = (n) =>
  new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD" }).format(Number(n) || 0);

export const todayIso = () => {
  const d = new Date();
  const off = d.getTimezoneOffset() * 60000;
  return new Date(d.getTime() - off).toISOString().slice(0, 10);
};

export const fmtShortDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(`${String(iso).slice(0, 10)}T12:00:00`).toLocaleDateString("en-CA", { month: "short", day: "numeric", year: "2-digit" });
  } catch { return iso; }
};

export const monthLabel = (iso) => {
  try {
    return new Date(`${String(iso).slice(0, 7)}-01T12:00:00`).toLocaleDateString("en-CA", { month: "long", year: "numeric" });
  } catch { return iso; }
};

/** Group a sorted expense list into [{key, label, total, items}] by month. */
export const groupByMonth = (items) => {
  const out = [];
  const idx = new Map();
  for (const e of items) {
    const key = String(e.date || "").slice(0, 7);
    if (!idx.has(key)) {
      idx.set(key, out.length);
      out.push({ key, label: monthLabel(e.date), total: 0, items: [] });
    }
    const g = out[idx.get(key)];
    g.total += Number(e.total) || 0;
    g.items.push(e);
  }
  return out;
};

export const DATE_RANGES = [
  { key: "12m", label: "Last 12 months" },
  { key: "month", label: "This month" },
  { key: "last_month", label: "Last month" },
  { key: "ytd", label: "This year" },
  { key: "all", label: "All time" },
];

export const rangeBounds = (key) => {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();
  const iso = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
  switch (key) {
    case "month": return { date_from: iso(new Date(y, m, 1)), date_to: iso(new Date(y, m + 1, 0)) };
    case "last_month": return { date_from: iso(new Date(y, m - 1, 1)), date_to: iso(new Date(y, m, 0)) };
    case "ytd": return { date_from: `${y}-01-01`, date_to: iso(now) };
    case "12m": return { date_from: iso(new Date(y - 1, m, now.getDate())), date_to: iso(now) };
    default: return {};
  }
};

export const PAY_METHODS = [
  { key: "credit", label: "Credit" },
  { key: "debit", label: "Debit" },
  { key: "cheque", label: "Cheque" },
  { key: "cash", label: "Cash" },
];

export const TAX_MODES = [
  { key: "excluded", label: "Excluded from amounts" },
  { key: "included", label: "Included in amounts" },
  { key: "none", label: "Not applicable" },
];

export const inputCls =
  "h-10 w-full rounded-md border border-white/15 bg-white/5 px-2 text-sm text-white placeholder:text-white/30 focus:border-[#1a3fd1] focus:outline-none";
export const labelCls = "font-mono text-[10px] uppercase tracking-widest text-white/50";
export const cardCls = "rounded-lg border border-white/10 bg-white/[0.02] p-4";
